import styled from "@emotion/native"
import type { CountryItem } from "../components/CountryPicker"
import { Text } from "./Typography"

export type CountryButtonProps = {
  item: CountryItem
  name: string
  onPress?: () => void
}

export function CountryButton({ item, name, onPress }: CountryButtonProps) {
  return (
    <Row onPress={onPress} testID="countryCodesPickerCountryButton" accessibilityRole="button">
      <Leading>
        <Text type="body1">{item.flag}</Text>
        <DialCode type="body1" color="royalBlue">
          {item.dial_code}
        </DialCode>
      </Leading>
      <NameSlot>
        <Text type="body2" color="primary" align="right" numberOfLines={1}>
          {name}
        </Text>
      </NameSlot>
    </Row>
  )
}

const Row = styled.Pressable`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  margin-bottom: 6px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.phoneNumberInput.backgroundColor};
`

const Leading = styled.View`
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
  column-gap: 10px;
`

const DialCode = styled(Text)`
  min-width: 48px;
`

const NameSlot = styled.View`
  flex: 1;
  margin-left: 16px;
  align-items: flex-end;
  justify-content: center;
`
